/**
 * A map of system-icon-name to human-friendly-icon-name
 */
export const IconNameMap = {
  none: "None",
  add: "Add",
  "alarm-clock": "Alarm Clock",
  "arrow-down": "Arrow Down",
  "arrow-down-right": "Arrow Down Right",
  "arrow-down-left": "Arrow Down Left",
  "arrow-left": "Arrow Left",
  "arrow-right": "Arrow Right",
  "arrow-up": "Arrow Up",
  "arrow-up-right": "Arrow Up Right",
  attachment: "Attachment",
  bank: "Bank",
  bell: "Bell",
  bolt: "bolt",
  branch: "Branch",
  "check-circle": "Check Circle",
  "check-mark": "Check Mark",
  "chevron-down": "Chevron Down",
  "chevron-end": "Chevron End",
  "chevron-left": "Chevron Left",
  "chevron-right": "Chevron Right",
  "chevron-start": "Chevron Start",
  "chevron-up": "Chevron Up",
  clock: "Clock",
  copy: "Copy",
  "credit-card": "Credit Card",
  "customer-service": "Customer Service",
  delete: "Delete",
  document: "Document",
  dollar: "Dollar",
  "dollar-circle": "Dollar Circle",
  download: "Download",
  edit: "Edit",
  "ellipsis-circle": "Ellipsis Circle",
  "ellipsis-vertical": "Ellipsis Vertical",
  envelope: "Envelope",
  eye: "Eye",
  "eye-slash": "Eye Slash",
  "face-id": "Face Id",
  filter: "Filter",
  globe: "Globe",
  grabber: "Grabber",
  grid: "Grid",
  history: "History",
  home: "Home",
  "info-circle": "Info Circle",
  "link-out": "Link Out",
  "list-tree": "List Tree",
  location: "Location",
  lock: "Lock",
  "lock-open": "Lock Open",
  "log-out": "Log Out",
  medical: "Medical",
  "menu-bars": "Menu Bars",
  "menu-grid": "Menu Grid",
  "message-dots": "Message Dots",
  phone: "Phone",
  "pill-bottle": "Pill Bottle",
  placeholder: "Placeholder",
  print: "Print",
  "question-circle": "Question Circle",
  redo: "Redo",
  refresh: "Refresh",
  remove: "Remove",
  scale: "Scale",
  search: "Search",
  series: "Series",
  settings: "Settings",
  "shield-check": "Shield Check",
  shipping: "Shipping",
  "star-empty": "Star Empty",
  "star-filled": "Star Filled",
  "thumbs-down": "Thumbs Down",
  "thumbs-up": "Thumbs Up",
  undo: "Undo",
  upload: "Upload",
  user: "User",
  "warning-circle": "Warning Circle",
  "x-circle": "X Circle",
  "x-close": "X Close",
  x: "X",
} as const;

/**
 * The set of available icon names.
 */
export type IconName = keyof typeof IconNameMap;
